import { spacing } from "app/shared/styles/spacing";
import { useMobileMediaQuery } from "app/shared/util/media-query";
import React, { useImperativeHandle, useState } from "react";
import { useTranslation } from "react-i18next";
import { StatusBar, StyleSheet, useWindowDimensions, View } from "react-native";
import Modal from "react-native-modal";
import { Button, Surface, useTheme } from "react-native-paper";
import { Block } from "../../blocks/block";

export const createGlobalModal = () => {
  const ref = React.createRef<any>();
  return ref;
};

export const globalModal = {
  show: (content: JSX.Element, globalModalRef: React.RefObject<any>) => {
    globalModalRef?.current?.show(content);
  },
  hide: (globalModalRef: React.RefObject<any>) => {
    globalModalRef?.current?.hide();
  },
};

const GlobalModal = React.forwardRef((props, ref) => {
  const [visible, setVisible] = useState<boolean>(false);
  const [content, setContent] = useState<JSX.Element>();
  const { t } = useTranslation();
  const { colors } = useTheme();
  const { width, height } = useWindowDimensions();
  const isMobile = useMobileMediaQuery();

  const styles = React.useMemo(
    () =>
      StyleSheet.create({
        modalContainerStyle: {
          alignSelf: "center",
          height: height * 0.7,
          minHeight: 300,
          borderRadius: 10,
        },
      }),
    [height],
  );

  useImperativeHandle(ref, () => {
    return { show: show, hide: hide };
  });

  const show = (_content: JSX.Element) => {
    setContent(_content);
    setVisible(true);
  };

  const hide = () => {
    setVisible(false);
  };

  const FormBottom = (
    <React.Fragment>
      <Block row middle center p={spacing.medium}>
        <Button color={colors.primary} onPress={() => hide()} mode="contained">
          {t("COMMON_DONG")}
        </Button>
      </Block>
    </React.Fragment>
  );

  const styleBackdrop: any = {
    position: "fixed",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    backgroundColor: "#000",
  };

  const customBackdrop = <View style={styleBackdrop} />;

  return (
    <Modal
      deviceHeight={height}
      deviceWidth={width}
      onBackdropPress={() => hide()}
      animationIn="slideInUp"
      customBackdrop={customBackdrop}
      animationOut="slideOutUp"
      hideModalContentWhileAnimating
      isVisible={visible}>
      <StatusBar translucent backgroundColor={"rgba(0,0,0,0.6)"} barStyle={"light-content"} />
      <Surface style={[styles.modalContainerStyle, isMobile ? { width: width * 0.9 } : { width: 550 }]}>
        <View style={{ flex: 1 }}>{content}</View>
        {FormBottom}
      </Surface>
    </Modal>
  );
});

export default GlobalModal;
